import { useQuery } from "@tanstack/react-query";
import { Link } from "@/lib/router-compat";
import { CouponBrandCard } from "@/components/coupons/CouponBrandCard";
import { Button } from "@/components/ui/button";
import { homeCouponsQueryOptions } from "@/lib/homeQueries";

export const HomeExclusiveCoupons = () => {
  const { data = [] } = useQuery(homeCouponsQueryOptions());
  const exclusive = data.filter((c) => c.is_exclusive);
  // Exclusivos reais primeiro; completa a vitrine sem repetir lojas.
  const list = [...exclusive, ...data.filter((c) => !c.is_exclusive)].slice(0, 4);
  if (list.length === 0) return null;
  const title = "Cupons para economizar ainda mais";

  return (
    <section className="bg-background py-10 md:py-14" aria-labelledby="home-exclusivos">
      <div className="container">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 id="home-exclusivos" className="font-display text-2xl md:text-3xl font-bold">{title}</h2>
            <p className="mt-1 text-muted-foreground">Códigos ativos, selecionados uma vez por loja e com os exclusivos primeiro.</p>
          </div>
          <Button asChild variant="outline"><Link to="/cupons-de-desconto">Ver todos os cupons</Link></Button>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((c) => <CouponBrandCard key={c.id} coupon={c} />)}
        </div>
      </div>
    </section>
  );
};
